<template>
  <div class="load" :class="{hide:hidden }">
    <canvas id="evolve-loader" height="100" width="100"></canvas>
  </div>
</template>

<script>
  import "common/js/requestAnimationFrame.min"

  export default {
    name: 'v-loading',
    props:{
      hidden:{
        type: Boolean
      }
    },
    created() {
      this.$nextTick(() => {
        this.loading();
      })
    },
    methods: {
      loading() {
        let canvas = document.getElementById('evolve-loader');
        let ctx = canvas.getContext('2d');
        let duration = 666.667;
        let durationRadiance = 2000;
        let radius = 26;
        let start = null;

        function drawEvolve(timestamp) {
          if (!start) {
            start = timestamp;
          }
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.translate(canvas.width / 2, canvas.height / 2);
          let remainder = (timestamp - start) % duration;
          let startAngle = Math.PI * (remainder / duration) * 2;
          let endAngle = startAngle + Math.PI;
          let degrees = 360 * remainder / duration;
          // Drawing the main arc
          ctx.lineWidth = 5;
          ctx.strokeStyle = 'rgba(166, 158, 132, 1)';
          ctx.beginPath();
          ctx.arc(0, 0, radius, startAngle, endAngle);
          ctx.stroke();
          ctx.closePath();
          // Drawing the gradient arcs
          ctx.globalCompositeOperation = 'destination-out';
          let gradientCounter = null;
          let startingLength = 0.5;
          let gradientLength = 0.5;
          let gradientIncrementer = 0.05;
          while (gradientLength - gradientIncrementer > -gradientIncrementer) {
            let arcOpacity = 1 - gradientLength / startingLength;
            ctx.strokeStyle = 'rgba(166, 158, 132, ' + arcOpacity + ')';
            ctx.beginPath();
            ctx.arc(0, 0, radius, startAngle + gradientLength, startAngle + (gradientLength + gradientIncrementer));
            ctx.stroke();
            ctx.closePath();
            gradientLength = gradientLength - gradientIncrementer;
          }
          // Drawing the outer arcs
          ctx.globalCompositeOperation = 'source-over';
          let arcWidth = 2;
          let oRemainder = (timestamp - start) % durationRadiance;
          let oRemainderPercentage = oRemainder / durationRadiance;
          let firstArcTriggerPoint = 0.66;
          let secondArcTriggerPoint = 0.83;
          if (oRemainderPercentage >= firstArcTriggerPoint) {
            let deltaTotal = secondArcTriggerPoint - firstArcTriggerPoint;
            let deltaChange = oRemainderPercentage - firstArcTriggerPoint;
            let deltaProgress = deltaChange / deltaTotal;
            let arcRadius = radius + (deltaProgress * 19);
            let arcAlpha = secondArcTriggerPoint - deltaProgress;
            ctx.lineWidth = arcWidth;
            ctx.strokeStyle = 'rgba(166, 158, 132, ' + arcAlpha + ')';
            ctx.beginPath();
            ctx.arc(0, 0, arcRadius, 0, Math.PI * 2);
            ctx.stroke();
          }
          if (oRemainderPercentage >= secondArcTriggerPoint) {
            let deltaTotal = 1 - secondArcTriggerPoint;
            let deltaChange = oRemainderPercentage - secondArcTriggerPoint;
            let deltaProgress = deltaChange / deltaTotal;
            let arcRadius = radius + (deltaProgress * 19);
            let arcAlpha = 1 - deltaProgress;
            ctx.lineWidth = arcWidth;
            ctx.strokeStyle = 'rgba(166, 158, 132, ' + arcAlpha + ')';
            ctx.beginPath();
            ctx.arc(0, 0, arcRadius, 0, Math.PI * 2);
            ctx.stroke();
          }
          window.requestAnimationFrame(drawEvolve);
        }
        window.requestAnimationFrame(drawEvolve);
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "~common/scss/mixin";
  .load {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 999999;
    transition: all 0.3s;
    canvas{
      @include trans-center(absolute);
    }
    &.hide{
      opacity: 0;
      visibility: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VLoading.vue